import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_CLOTHING_CATEGORY_ROUTER } from "../../../services/api-config";

// ===== Enums =====
export enum CLOTHING_CATEGORY_STATUS {
  INACTIVE = 0,
  ACTIVE = 1,
}

export const CLOTHING_CATEGORY_STATUS_NAME: Record<number, string> = {
  [CLOTHING_CATEGORY_STATUS.INACTIVE]: "Ngưng sử dụng",
  [CLOTHING_CATEGORY_STATUS.ACTIVE]: "Đang sử dụng",
};

// ===== Interfaces =====
export interface ClothingCategory {
  id: number;
  name: string;
  code?: string | null;
  sort_order: number;
  status: number;
  created_at: string;
  updated_at: string;
}

export interface ClothingCategoryListFilters {
  status?: number;
  key_search?: string;
}

export interface CreateClothingCategoryPayload {
  name: string;
  code?: string;
  sort_order?: number;
}

export interface UpdateClothingCategoryPayload {
  name?: string;
  code?: string;
  sort_order?: number;
  status?: number;
}

// ===== Service =====
const ClothingCategoryService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ClothingCategory[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (params?: ClothingCategoryListFilters) =>
        request({
          endPoint: API_CLOTHING_CATEGORY_ROUTER.API_LIST,
          data: params || {},
        }),
      response: baseResponse,
      loading,
    };
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ClothingCategory>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (payload: CreateClothingCategoryPayload) =>
        request({
          endPoint: API_CLOTHING_CATEGORY_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ClothingCategory>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (id: number, payload: UpdateClothingCategoryPayload) =>
        request({
          endPoint: API_CLOTHING_CATEGORY_ROUTER.API_UPDATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },
};

export default ClothingCategoryService;
